<template>
  <div class="headbar-box">
    <div v-if="userInfo.status === -2" class="email-not-verify">
      <i class="el-icon-warning"></i>
      <span style="font-weight: 600"
        >You need to activate your account( {{ userInfo.email }} )</span
      >
      <el-button size="small" @click="reSendEmail">Resend Email</el-button>
    </div>
    <div class="headbar max-width-box" id="headbar">
      <span class="hamburg">
        <a href="/"><span class="spanlogo"></span></a>
      </span>
      <!-- 工具栏 -->
      <span class="toolbar">
        <div class="search" id="search-box">
          <el-input
            v-model="queryStr"
            placeholder="What do you want to learn?"
            prefix-icon="el-icon-search"
            @keyup.enter.native="search"
          >
            <el-button slot="append" @click.native="search">search</el-button>
          </el-input>
        </div>
        <div style="display: flex; height: 100%">
          <el-menu
            class="menuItem"
            mode="horizontal"
            :default-active="defaultActive"
            @select="OnMenuSelect"
          >
            <!-- 未登录时，message 和订单 两个菜单不显示 -->
            <el-menu-item index="course">
              <span class="real-title" title="Courses">Courses</span>
            </el-menu-item>
            <el-menu-item index="schoolclubs">
              <span class="real-title" title="School Clubs">School Clubs</span>
            </el-menu-item>

            <el-menu-item
              v-if="xToken && userInfo.usertype === 0"
              class="teach-on-covey"
              index="teach"
            >
              <div id="teach_on_covey">
                <span>Teach on Covey</span>
              </div>
            </el-menu-item>
          </el-menu>

          <el-menu
            class="menuItem"
            mode="horizontal"
            :default-active="defaultActiveUser"
            menu-trigger="hover"
            @select="OnMenuSelectRight"
          >
            <el-menu-item
              @click="openSelectShoolDialog"
              index="/selectSchool"
              style="color: #7e8088"
            >
              <i style="margin-right: 0" class="el-icon-location"></i>
              <span class="real-title" :title="schoolName">{{
                schoolName || "Location"
              }}</span>
            </el-menu-item>
            <div class="login" @click="gotoLogin" v-if="!userInfo.login_name">
              Log in
            </div>
            <div
              class="sign-up"
              @click="gotoRegistry"
              v-if="!userInfo.login_name"
              style="margin-left: 32px"
            >
              Join Covey
            </div>
            <div style="height: 100%" v-if="userInfo.login_name">
              <el-submenu :popper-append-to-body="false" index="9528">
                <template slot="title">
                  <!-- <img class="user-avatar" style="width:32px;height:32px;border-radius:50%;" :src="userInfo.photo ? userInfo.photo : defaultAvatar"/> -->

                  <el-avatar
                    class="user-avatar"
                    :size="32"
                    :src="userInfo.photo ? userInfo.photo : defaultAvatar"
                  ></el-avatar>
                  <span
                    class="real-title-username"
                    :title="
                      userInfo.realname
                        ? userInfo.realname
                        : userInfo.login_name
                    "
                  >
                    {{
                      userInfo.realname
                        ? userInfo.realname
                        : userInfo.login_name
                    }}
                  </span>
                </template>
                <div v-if="userInfo.usertype === 0">
                  <el-menu-item index="/myinfo/profile">
                    <span>Account Center</span>
                  </el-menu-item>

                  <el-menu-item index="/notification" v-if="xToken">
                    <span class="real-title" title="My Messages"
                      >My Messages</span
                    >
                    <el-badge
                      v-if="messageNum > 0 || notificationNum > 0"
                      class="mark"
                      :value="messageNum + notificationNum"
                    />
                  </el-menu-item>
                  <el-menu-item index="/myinfo/classschedule">
                    <span>My Schedule</span>
                  </el-menu-item>

                  <el-menu-item index="/order/purchased" v-if="xToken">
                    <span class="real-title" title="My Orders">My Orders</span>
                  </el-menu-item>
                  <el-menu-item index="/myinfo/wallet">
                    <span>My Wallet</span>
                  </el-menu-item>
                  <el-divider></el-divider>
                  <el-menu-item index="/teach">
                    <span>Teach on Covey</span>
                  </el-menu-item>
                  <el-menu-item index="/teach/courses">
                    <span>Manage Courses</span>
                  </el-menu-item>
                  <el-divider></el-divider>
                  <el-menu-item index="/logout" @click="logout">
                    <span>Logout</span>
                  </el-menu-item>
                </div>

                <div v-if="userInfo.usertype === 1">
                  <el-menu-item
                    v-for="(item, index) of groupRouter"
                    :key="index"
                    :index="item.id"
                  >
                    <!-- <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                      "
                    > -->
                    <span class="real-title" :title="item.name">{{
                      item.name
                    }}</span>
                    <el-badge
                      v-if="item.path.indexOf('messages') > 0 && messageNum > 0"
                      class="mark"
                      :value="messageNum"
                    />
                    <el-badge
                      v-if="
                        item.path.indexOf('notification') > 0 &&
                        notificationNum > 0
                      "
                      class="mark"
                      :value="notificationNum"
                    />
                    <!-- </div> -->
                  </el-menu-item>

                  <el-menu-item index="104" @click="logout">
                    <span>Logout</span>
                  </el-menu-item>
                </div>
              </el-submenu>
            </div>
          </el-menu>
        </div>
      </span>
      <el-dialog
        :visible.sync="loginDialog"
        :show-close="true"
        append-to-body
        :close-on-click-modal="false"
        custom-class="login-dialog"
        @close="closeLoginDialog"
      >
        <div class="login-box">
          <div class="login-pannel">
            <div class="re-title">Welcome back!</div>

            <el-form :model="loginForm" ref="loginForm_dialog" :rules="rules">
              <el-form-item prop="login_name">
                <div class="password-label">
                  <div>Email address</div>
                </div>
                <el-input
                  v-model="loginForm.login_name"
                  placeholder="Enter an email address"
                ></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <div class="password-label">
                  <div>Password</div>
                  <div class="forgot-password" @click="forgotPwd">
                    Forgot Password
                  </div>
                </div>
                <el-input
                  type="password"
                  v-model="loginForm.password"
                  placeholder="Enter your password"
                >
                  <i
                    slot="suffix"
                    class="el-icon-view"
                    style="margin-right: 5px"
                    @mousedown="showPass($event)"
                    @mouseup="hidePass($event)"
                  ></i>
                </el-input>
              </el-form-item>
            </el-form>

            <div
              class="re-login re-third"
              @click="login"
              v-loading="loginLoading"
            >
              Log in
            </div>
            <div class="remeber-box">
              <span>
                <el-checkbox v-model="rememberMe">Remember me</el-checkbox>
              </span>
            </div>
            <div class="re-google re-third" @click.stop="oauthToGoogle">
              <img src="@/assets/icon/google.png" />
              Log in with Google
            </div>
            <div class="re-facebook re-third" @click.stop="oauthToFacebook">
              <img src="@/assets/icon/facebook.png" />
              Log in with Facebook
            </div>
            <div class="re-tips">
              New to Covey? <span @click="toSignUp">Sign up</span>
            </div>
            <!-- <div class="re-register">
              <div class="to-register">Register for School Clubs</div>
            </div> -->
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="schoolDialog"
        :show-close="true"
        append-to-body
        @close="colseSchoolDialog"
        custom-class="school-dialog"
      >
        <div class="school-header">Pick your School</div>
        <div class="school-body" v-loading="loadingSchool">
          <el-scrollbar class="search-scrollbar">
            <div class="search-list-li">
              <!-- <el-tooltip
                effect="light"
                :content="item.content ? item.content : ''"
                placement="bottom-start"
              > -->
              <div
                class="search-li"
                v-for="(item, index) in schoolList"
                :key="index"
                @click="selectShool(item)"
              >
                {{ item.name }}
              </div>
              <!-- </el-tooltip> -->
            </div>
          </el-scrollbar>
        </div>
      </el-dialog>
      <!-- <el-dialog :visible.sync="schoolDialog" :show-close="true" append-to-body @close="colseSchoolDialog" custom-class="school-dialog">
                <div class="school-header">Find your School</div>
                <div class="te-search-box">
                    <div class="te-search">
                        <img src="@/assets/icon/search.png" />
                        <el-input v-model="searchSchoolForm.searchschool" placeholder="Search your school" @keyup.enter.native="searchSchoolList"></el-input>
                        <el-button @click.native="searchSchoolList">search</el-button>
                    </div>
                </div>
                <div class="search-cont-box">
                    <div class="search-cont">
                        <div class="search-bar">
                            <div class="search-bar-li" v-for="(item, index) in alphabetList" :key="index" @click="setCurrentBarIndex(item, index)">
                                <div class="bar-li" :class="{ barcolor: index === currentBarIndex }">
                                    {{ item }}
                                </div>
                                <div :class="{ barunderline: index === currentBarIndex }"></div>
                            </div>
                        </div>
                        <div class="search-list">
                            <el-scrollbar class="search-scrollbar">
                                <div class="search-list-box" v-loading="loadingSchool">
                                    <div class="search-list-li" v-for="(item, index) in schoolList" :key="index">
                                        <div class="search-li" @click="selectShool(item)">
                                            {{ item.name }}
                                        </div>
                                    </div>
                                </div>
                            </el-scrollbar>
                        </div>
                    </div>
                </div>
            </el-dialog> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Cookies from "js-cookie";
import { personalRouter, groupRouter } from "@/utils/global";
import { isEmail } from "@/utils/validate";
import { Md5ChangePass, scopeDomain, secreKey } from "@/utils/comm";
// import ThemePicker from "@/components/ThemePicker"
export default {
  data() {
    let validateEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please fill in the email."));
      } else if (!isEmail(value)) {
        callback(new Error("Please enter a valid email."));
      } else callback();
    };
    return {
      personalRouter: personalRouter,
      groupRouter: groupRouter,
      defaultActive: "", //当前选中的tab
      defaultActiveUser: "", //右侧临时选中的tab
      loading: false,
      dialogFormVisible: false,
      dialogUsFormVisible: false,
      newform: { newname: "" },
      form: { oldPwd: "", newPwd: "", chekPwd: "" },
      myInfoDialogVisible: false, //查看个人信息dialog
      // 新增编辑界面数据
      searchSchoolForm: {
        searchschool: "",
      },
      loadingSchool: false,
      userForm: {
        id: 0,
        login_name: "",
        user_name: "",
        phonenumber: "",
        password: "",
        opassword: "",
        status: 1,
        checkPassword: "",
      },
      queryStr: "",
      schoolList: [],
      schoolName: "",
      statusSelected: "student",
      loginForm: {
        login_name: "",
        password: "",
      },
      schoolDialog: false,
      loginLoading: false,
      rememberMe: false,
      currentBarIndex: 0,
      alphabetList: [
        "#",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
      rules: {
        login_name: [
          { required: true, validator: validateEmail, trigger: "blur" },
        ],
        password: [
          {
            required: true,
            message: "Please fill in the password.",
            trigger: "blur",
          },
        ],
      },
      myInterval: "",
      // loginDialogVisible: false,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.app.userInfo,
      navTree: (state) => state.menu.navTree,
      defaultAvatar: (state) => state.app.defaultAvatar,
      schoolId: (state) => state.app.schoolId,
      xToken: (state) => state.app.token,
      messageNum: (state) => state.app.messageNum,
      notificationNum: (state) => state.app.notificationNum,
      // loginDialog:(state)=> state.app.loginDialog,
    }),
    loginDialog: {
      get() {
        return this.$store.state.app.loginDialog;
      },
      set(val) {
        // this.loginDialogVisible = val;
      },
    },
  },
  watch: {
    "$route.path": function (newVal, oldVal) {
      this.queryStr = "";
      if (newVal === "/home") {
        //不固定headbar
        window.addEventListener("scroll", this.scrollToTop);
      } else {
        //固定headbar
        document.querySelector("#search-box").style.visibility = "hidden";
        if (newVal === "/search") {
          document.querySelector("#search-box").style.visibility = "visible";
        }
        window.removeEventListener("scroll", this.scrollToTop);
      }

      var route_this = this.$route.fullPath;

      this.defaultActive = route_this.substr(1);
    },
    userInfo: {
      handler(newVal, oldVal) {
        this.getSchoolList();
      },
    },
  },
  created() {
    this.$nextTick(() => {
      if (!this.xToken) {
        this.$store.commit("handleUserInfo", {});
      }
    });
    this.getUserInfoFn();
    var route_this = this.$route.fullPath;

    this.defaultActive = route_this.substr(1);
    this.getSchoolList();
  },
  mounted() {
    let { errCode } = this.$route.query;

    this.loginForm.login_name = Cookies.get("login_name");
    if (Cookies.get("password")) {
      let temp_p = window.atob(Cookies.get("password"));
      this.loginForm.password = temp_p.substring(temp_p.indexOf(secreKey), -1);
    }
    this.rememberMe = Cookies.get("rememberMe") === "true" ? true : false;

    let { role_flag } = this.userInfo;
    if (role_flag !== undefined && role_flag !== 1) {
      let call = this.$store.state.app.callback;
      let p = navigator.platform;
      let system = p.indexOf("Win") === 0 || p.indexOf("Mac") === 0;
      if (call && system) {
        //let note = Notice()
        //if(!note) return
        this.$store.commit("onCallback", false);
      }
    }
    const s = document.createElement("script");
    window.addEventListener("scroll", this.scrollToTop);

    if (this.$route.path === "/home") {
      //不固定headbar
      window.addEventListener("scroll", this.scrollToTop);
    } else {
      //固定headbar
      if (this.$route.path === "/search") {
        document.querySelector("#search-box").style.visibility = "visible";
      }
      window.removeEventListener("scroll", this.scrollToTop);
    }
    this.initSearchBox();
    // this.myAnimationB();
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
    this.myInterval = null;
  },
  methods: {
    //自定义密码转文本显示框
    showPass: function (e) {
      let { type } = e.path[3].firstElementChild;
      e.path[3].firstElementChild.type = "text";
    },
    hidePass(e) {
      let { type } = e.path[3].firstElementChild;
      e.path[3].firstElementChild.type = "password";
    },
    //重新发送邮件
    reSendEmail() {
      this.$api.courseApi
        .sendMailVerify({
          user_id: this.userInfo.id,
          mail: this.userInfo.email,
        })
        .then((res) => {
          if (res.err === 0) {
            this.$message.success(res.message);
          }
        });
    },
    initSearchBox() {
      document
        .querySelector("#search-box > div > input")
        .addEventListener("focus", () => {
          document.querySelector("#search-box > div > span").style.color =
            "#f48c06";
        });
      document
        .querySelector("#search-box > div > input")
        .addEventListener("blur", () => {
          document.querySelector("#search-box > div > span").style.color =
            "#c0c4cc";
        });
    },
    async oauthToGoogle() {
      window.location.href =
        "https://accounts.google.com/o/oauth2/v2/auth?access_type=offline&scope=https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile&response_type=code&client_id=619151573090-9k02nb4ufr9ufgla1f0brh4mm4gnd5ee.apps.googleusercontent.com&redirect_uri=https://api.coveycampus.com/api/v1.0/coveyuser/googlecallback";
    },
    oauthToFacebook() {
      // await this.$api.userApi.oauth2ToLogin();
      // window.location.href =
      // "https://accounts.google.com/o/oauth2/v2/auth?access_type=offline&scope=https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile&response_type=code&client_id=619151573090-9k02nb4ufr9ufgla1f0brh4mm4gnd5ee.apps.googleusercontent.com&redirect_uri=http://localhost:30000/api/v1.0/coveyuser/oauth2callback";
      window.location.href =
        "https://www.facebook.com/v13.0/dialog/oauth?client_id=685542959371631&redirect_uri=https://api.coveycampus.com/api/v1.0/coveyuser/facebookcallback";
    },
    toSignUp() {
      this.$router.push("/registry");
    },
    forgotPwd() {
      let route = this.$router.resolve({ path: "/forgotpwd" });
      window.open(route.href, "_blank");
    },
    chooseStatus(status) {
      this.statusSelected = status;
    },
    setCurrentBarIndex(content, index) {
      this.currentBarIndex = index;
      if (content === "#") {
        this.getSchoolList();
      } else {
        this.getSchoolList({ searchschool: content, type: 1 });
      }
    },
    searchSchoolList() {
      this.currentBarIndex = -1;
      this.getSchoolList({
        searchschool: this.searchSchoolForm.searchschool,
        type: 2,
      });
    },
    login() {
      //todo 记住密码
      this.$refs["loginForm_dialog"].validate((valid) => {
        if (!valid) return;

        try {
          Cookies.set("rememberMe", this.rememberMe);
          this.loginLoading = true;
          let data = { ...this.loginForm };
          Cookies.set("login_name", data.login_name, { expires: 7 });
          let tempPassword = window.btoa(data.password + secreKey);

          data.password = Md5ChangePass(data.password);
          this.$api.comApi.login(data).then((res) => {
            if (res.status === "0") {
              if (this.rememberMe) {
                //如果记住密码 存到cookie 7天过期
                Cookies.set("password", tempPassword, { expires: 7 });
              } else {
                Cookies.set("password", "", { expires: 7 });
              }
              //登录成功
              Cookies.set(scopeDomain.name, res.data.token, {
                expires: 3,
                domain: scopeDomain.path,
              }); //设置cookie
              this.$store.commit("setToken", res.data.token);
              this.$store.commit("handleUserInfo", res.data.userInfo || {}); // 绑定用户信息
              this.$store.commit("SET_USERINFO", res.data.userInfo || {}); // 绑定用户信息
              this.$store.commit("menuRouteLoaded", false); // 要求重新加载导航菜单
              this.$store.commit("onCallback", true);
              // this.$router.push("/"); // 登录成功，跳转到对应路由
              this.$store.commit("SET_LOGIN_DIALOG", false); //关闭登录dialog
            } else {
              this.$message.error(res.message);
            }
            this.loginLoading = false;
          });
        } catch (err) {
          this.loginLoading = false;
          this.$message.error(err);
        }
      });
    },
    //滚动事件
    scrollToTop() {
      let screenWidth = document.body.clientWidth;
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (screenWidth < 120) {
      } else {
        if (scrollTop > 0) {
        } else {
        }
        if (scrollTop > 301) {
          document.querySelector("#search-box").style.visibility = "visible";
        } else {
          document.querySelector("#search-box").style.visibility = "hidden";
        }
      }
    },
    //注册
    gotoRegistry() {
      this.$router.push({ path: "/registry" });
    },
    //登录
    gotoLogin() {
      this.$store.commit("SET_LOGIN_DIALOG", true); //打开登录dialog
      this.loginForm.login_name = Cookies.get("login_name");
      if (Cookies.get("password")) {
        let temp_p = window.atob(Cookies.get("password"));
        this.loginForm.password = temp_p.substring(
          temp_p.indexOf(secreKey),
          -1
        );
      }
      this.rememberMe = Cookies.get("rememberMe") === "true" ? true : false;
    },
    openSelectShoolDialog() {
      this.schoolDialog = true;

      this.currentBarIndex = 0;
      this.getSchoolList();
      document.getElementById("search-box").setAttribute("style", "");
    },
    //获取学校下拉列表
    getSchoolList(params) {
      this.loadingSchool = true;
      this.$api.courseApi.getSchoolList(params).then((res) => {
        if (res.status === "0") {
          console.log("schoolId---", this.schoolId);
          this.schoolList = res.data.rows;
          for (let item of this.schoolList) {
            if (parseInt(this.schoolId) === item.id) {
              this.schoolName = item.name;
              break;
            }
          }
        }
      });
      this.loadingSchool = false;
    },
    //选择学校
    selectShool(school) {
      this.schoolName = school.name;
      this.$store.commit("SET_SCHOOL_ID", school.id || -1);
      this.schoolDialog = false;
    },
    //查看个人信息
    goMyinfo() {
      this.$router.push("/myinfo/myinfo");
      this.$store.commit("onCollapse", true);
    },
    //获取用户信息
    async getUserInfoFn() {
      if (this.loading) return;
      this.loading = true;
      const { status, data, message } = await this.$api.comApi.getUserInfo();
      if (status === "0") {
        this.$store.commit("handleUserInfo", data || {});
        this.$store.commit("SET_SCHOOL_ID", data.schoolId || -1);
        this.$store.commit("SET_USERINFO", data || {});
      }
      this.loading = false;
    },
    //自定义密码转文本显示框
    showPass: function (e) {
      let { type } = e.path[3].firstElementChild;
      let dom = e.target;
      dom.src = require(`@/assets/view${type == "password" ? "" : "_bi"}.png`);
      e.path[3].firstElementChild.type =
        type == "password" ? "text" : "password";
    },
    colseSchoolDialog() {
      this.schoolDialog = false;
    },
    //H5折叠
    // 退出登录
    logout: function () {
      this.$confirm("Are you sure you want to log out?", "", {
        type: "warning",
      })
        .then(() => {
          this.$router.push("/");
          Cookies.remove(scopeDomain.name, { domain: scopeDomain.path });
          this.$store.commit("menuRouteLoaded", false);
          localStorage.removeItem("USERINFO");
          this.$store.commit("clearUserInfo");
          this.schoolName = "";
          if (!this.rememberMe) this.loginForm.password = "";
          Cookies.set(scopeDomain.name, ""); //设置cookie
        })
        .catch(() => {});
    },

    //监听选中的tab
    OnMenuSelect(index, indexPath) {
      this.$router.push("/" + index);
    },
    //跳转到个人中心
    OnMenuSelectRight(index) {
      if (["/logout", "/selectSchool"].includes(index)) {
        return;
      }
      if (this.userInfo.usertype === 0) {
        this.$router.push(index);
      } else {
        for (let item of groupRouter) {
          if (item.id === index) {
            this.$router.push(item.path);
            return;
          }
        }
      }
    },
    search() {
      if (!this.queryStr) {
        return;
      }
      this.$router.push({
        path: "/search",
        query: {
          source: "headbar_top",
          query: this.queryStr,
        },
      });
    },
    closeLoginDialog() {
      this.$store.commit("SET_LOGIN_DIALOG", false); //关闭登录dialog
    },
    myAnimationB() {
      var myAnimation =
        window.requestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.msRequestAnimationFrame;

      var colors = [
        [255, 128, 0],
        [60, 255, 60],
        [255, 35, 98],
        [45, 175, 230],
        [255, 0, 255],
        [255, 128, 0],
      ];
      var step = 0;
      var colorIndices = [0, 1, 2, 3];

      //transition speed
      var gradientSpeed = 0.002;

      function updateGradient() {
        var c0_0 = colors[colorIndices[0]];
        var c0_1 = colors[colorIndices[1]];
        var c1_0 = colors[colorIndices[2]];
        var c1_1 = colors[colorIndices[3]];

        var istep = 1 - step;
        var r1 = Math.round(istep * c0_0[0] + step * c0_1[0]);
        var g1 = Math.round(istep * c0_0[1] + step * c0_1[1]);
        var b1 = Math.round(istep * c0_0[2] + step * c0_1[2]);
        var color1 = "rgb(" + r1 + "," + g1 + "," + b1 + ")";

        var r2 = Math.round(istep * c1_0[0] + step * c1_1[0]);
        var g2 = Math.round(istep * c1_0[1] + step * c1_1[1]);
        var b2 = Math.round(istep * c1_0[2] + step * c1_1[2]);
        var color2 = "rgb(" + r2 + "," + g2 + "," + b2 + ")";

        // "-moz-linear-gradient(left, " + color1 + " 0%, " + color2 + " 100%)";
        document.getElementById("teach_on_covey").style.background =
          "-webkit-gradient(linear, left top, right top, from(" +
          color1 +
          "), to(" +
          color2 +
          "))";
        step += gradientSpeed;
        if (step >= 1) {
          step %= 1;
          colorIndices[0] = colorIndices[1];
          colorIndices[2] = colorIndices[3];

          //pick two new target color indices
          //do not pick the same as the current one
          colorIndices[1] =
            (colorIndices[1] +
              Math.floor(1 + Math.random() * (colors.length - 1))) %
            colors.length;
          colorIndices[3] =
            (colorIndices[3] +
              Math.floor(1 + Math.random() * (colors.length - 1))) %
            colors.length;
        }
        myAnimation(updateGradient);
      }
      updateGradient();
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/utils/vw.scss";
$barColor: rgba(252, 233, 209, 1);
$fontColor: #201002;

.headbar-box {
  position: fixed;
  z-index: 100;
  width: 100%;
  top: 0;
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);

  .email-not-verify {
    font-size: 14px;
    background: #eacca0;
    padding: 8px 72px;
    line-height: 32px;
    i {
      margin-right: 5px;
    }
    .el-button {
      margin: auto;
      position: absolute;
      right: 72px;
    }
  }
}
.headbar {
  // padding: 0 vw(178);
  margin: 0 auto;
  height: 80px;
  display: flex;
  font-family: "PingFangSC-Semibold", "PingFang SC";
  font-size: 16px;
  font-weight: 600;
  transition: top 0.5s;
  // box-sizing: border-box;
  padding: 0 32px;
  /deep/.real-title {
    line-height: 20px;
  }
  .menuItem {
    display: flex;
    align-items: center;
    border: none;
    background: rgba(0, 0, 0, 0);
    .teach-on-covey {
      padding: 24px 20px !important;
      margin: 0 0px !important;
      // box-sizing: border-box;
      div {
        display: flex;
        align-items: center;
        padding: 2px 12px;
        margin: -2px -12px;
        border-radius: 18px;
        height: 100%;
        background: linear-gradient(155deg, #ffd49b 0%, #f48c06 100%);
        color: #fff;
        // transform: skewX(-7deg);
        span {
          // transform: skewX(7deg);
        }
      }
    }
    .el-menu-item {
      padding: 0;
      height: 100%;
      margin: 0 20px;
      font-size: 16px;
      border: none;
      color: #7e8088;
      vertical-align: top;
      display: flex;
      align-items: center;
      justify-content: space-between;
      line-height: 100%;
    }
    .el-menu-item.is-active {
      color: #f48c06;
    }
    .el-menu-item:hover {
      color: #f48c06;
    }
    /deep/.el-menu--popup .el-menu-item {
      line-height: 36px;
      height: 36px;
      font-weight: 600;
      font-size: 16px;
      padding: 0 8px;
      margin: 0 20px;
      border: none;
    }
    .real-title-username {
      max-width: 80px;
      text-align: right;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .user-avatar {
      margin-right: 8px;
    }

    /deep/ .el-submenu__title {
      border: none !important;
      padding: 0 !important;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 100%;
      color: #7e8088;
      line-height: 20px;
      &:hover {
        color: #f48c06;
        i {
          color: #f48c06;
        }
      }
      i {
        color: #7e8088;
      }
      .el-submenu__icon-arrow {
        position: static;
        margin: 0;
        right: 0;
        margin-left: 4px;
      }
    }
    .login {
      font-weight: 500;
      cursor: pointer;
      height: 36px;
      border: 2px solid #f48c06;
      padding: 4px 8px;
      box-sizing: border-box;
      border-radius: 4px;
      color: #f48c06;
    }
    .sign-up {
      font-weight: 500;
      cursor: pointer;
      background: #f48c06;
      padding: 8px;
      box-sizing: border-box;
      border-radius: 4px;
      color: #fff;
    }
    .el-divider {
      margin: 0 20px;
      width: auto;
    }
  }
  .el-submenu {
    height: 100%;
    // margin: 0 20px;
  }
  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus {
    color: #f48c06;
  }
  /deep/ .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
    transform: rotateZ(-90deg);
  }
  /deep/ .el-icon-arrow-down:before {
    //箭头样式
    content: "\e792" !important;
  }
  /deep/ .el-submenu__title:hover {
    //二级菜单 hover样式
    background: rgba(0, 0, 0, 0) !important;
  }
  .el-menu-item:hover {
    background: rgba(0, 0, 0, 0);
  }
  .el-menu-item:focus {
    background: rgba(0, 0, 0, 0);
  }
  .el-input__suffix {
    img {
      width: 26px;
      display: block;
      cursor: pointer;
      margin-top: 3px;
    }
  }
}
.hamburg {
  margin-right: 20px;
  .spanlogo {
    width: 113px;
    height: 78px;
    background-size: 100%;
    background-image: url("../../../assets/logo_gold.png");
    background-repeat: no-repeat;
    display: inline-block;
    background-position: center 50%;
  }
}
.toolbar {
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  border: none;
  #search-box {
    visibility: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    box-sizing: border-box;
    /deep/.el-input__prefix {
      transition: top 0s;
      .el-input__icon {
        transition: top 0s;
      }
    }
    /deep/.el-input-group__append {
      background: #f48c06;
      color: #fff;
      border: 1px solid #f48c06;
    }
    /deep/.el-input__inner {
      &:focus {
        border: 1px solid #f48c06;
      }
    }
  }
}

@media screen and (max-width: 540px) {
  .noneItem {
    display: none;
  }
}
</style>
